/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import CardWrapper from '../components/CardWrapper';
import ArticleSitecore from '../components/Cycle/Article/ArticleSitecore';
import AsideSitecore from '../components/Cycle/Aside/AsideSitecore';
import BaseNavigation from '../components/Cycle/BaseNavigation';
import BlogAuthor from '../components/Cycle/BlogAuthor/BlogAuthor';
import BlogCarousel from '../components/Cycle/BlogCarousel/BlogCarousel';
import BlogDivider from '../components/Cycle/BlogDivider/BlogDivider';
import BlogHero from '../components/Cycle/BlogHero/BlogHero';
import BlogSearch from '../components/Cycle/BlogSearch/BlogSearch';
import BlogTag from '../components/Cycle/BlogTag/BlogTag';
import BlogTags from '../components/Cycle/BlogTags/BlogTags';
import Breadcrumb from '../components/Cycle/Breadcrumb/Breadcrumb';
import Carousel from '../components/Cycle/Carousel/Carousel';
import CarouselStacked from '../components/Cycle/Carousel/CarouselStacked';
import StackedReviewCarousel from '../components/Cycle/Carousel/StackedReviewCarousel';
import CategorizedFaq from '../components/Cycle/CategorizedFaq/CategorizedFaq';
import CategorizedFaqList from '../components/Cycle/CategorizedFaq/subComponents/CategorizedFaqList';
import FaqCategory from '../components/Cycle/CategorizedFaq/subComponents/FaqCategory';
import FaqSubCategory from '../components/Cycle/CategorizedFaq/subComponents/FaqSubCategory';
import ClickSimulatorSitecore from '../components/Cycle/ClickSimulatorSitecore';
import CompareTableSitecore from '../components/Cycle/CompareTableSitecore';
import ContentToggleSitecore from '../components/Cycle/ContentToggleSitecore';
import CycleAnvaOnlineIframeSitecore from '../components/Cycle/CycleAnvaOnlineIframeSitecore';
import CycleCompareCoverageSitecore from '../components/Cycle/CycleCompareCoverageSitecore';
import CycleContentBlockSitecore from '../components/Cycle/CycleContentBlockSitecore';
import CycleCookieConsentSitecore from '../components/Cycle/CycleCookieConsentSitecore';
import CycleCookieToggleSitecore from '../components/Cycle/CycleCookieToggleSitecore';
import CycleCoverageSitecore from '../components/Cycle/CycleCoverageSitecore';
import CycleFaqSitecore from '../components/Cycle/CycleFaqSitecore';
import CycleFooterSitecore from '../components/Cycle/CycleFooterSitecore';
import CycleHeaderSitecore from '../components/Cycle/CycleHeaderSitecore';
import CycleHeadingSitecore from '../components/Cycle/CycleHeadingSitecore';
import CycleIframeSitecore from '../components/Cycle/CycleIframeSitecore';
import CycleIFrameSizeEmitterSitecore from '../components/Cycle/CycleIFrameSizeEmitterSitecore';
import CycleLanguageSwitchSitecore from '../components/Cycle/CycleLanguageSwitchSitecore';
import CycleLinkCardSitecore from '../components/Cycle/CycleLinkCardSitecore';
import CycleListSitecore from '../components/Cycle/CycleListSitecore';
import CycleNavigationSitecore from '../components/Cycle/CycleNavigationSitecore';
import CycleNotificationSitecore from '../components/Cycle/CycleNotificationSitecore';
import CyclePageIntroSitecore from '../components/Cycle/CyclePageIntroSitecore';
import CycleRadioNavigationSitecore from '../components/Cycle/CycleRadioNavigationSitecore';
import CycleSectionSitecore from '../components/Cycle/CycleSectionSitecore';
import CycleTileSitecore from '../components/Cycle/CycleTileSitecore';
import CycleTilesSitecore from '../components/Cycle/CycleTilesSitecore';
import FixedBox from '../components/Cycle/FixedBox/FixedBox';
import FixedLink from '../components/Cycle/FixedLink/FixedLink';
import GridComponentAdapterSitecore from '../components/Cycle/GridComponentAdapterSitecore';
import HorizontalCard from '../components/Cycle/HorizontalCard';
import HtmlSitecore from '../components/Cycle/HtmlSitecore/HtmlSitecore';
import IconButtonSitecore from '../components/Cycle/IconButtonSitecore';
import IframeCleanSitecore from '../components/Cycle/IframeCleanSitecore';
import ListContainer from '../components/Cycle/ListContainer/ListContainer';
import ListContentBlock from '../components/Cycle/ListContentBlock/ListContentBlock';
import LocationMap from '../components/Cycle/LocationMap/LocationMap';
import PortalSitecore from '../components/Cycle/Portals/PortalSitecore/PortalSitecore';
import PortalTargetSitecore from '../components/Cycle/Portals/PortalTargetSitecore/PortalTargetSitecore';
import premiumCalcSitecore from '../components/Cycle/premiumCalcSitecore';
import ProductCard from '../components/Cycle/ProductCard';
import RationalHero from '../components/Cycle/RationalHero/RationalHero';
import ReviewSitecore from '../components/Cycle/Review/ReviewSitecore';
import SocialMediaShare from '../components/Cycle/SocialMediaShare/SocialMediaShare';
import StickyBox from '../components/Cycle/StickyBox';
import StoryteqContainer from '../components/Cycle/StoryteqContainer';
import StructuredData from '../components/Cycle/StructuredData/StructuredData';
import StructuredDataBlog from '../components/Cycle/StructuredDataBlog/StructuredDataBlog';
import StructuredDataFaq from '../components/Cycle/StructuredDataFaq/StructuredDataFaq';
import SubGridSitecore from '../components/Cycle/Subgrid/SubGridSitecore';
import TopNavigationSitecore from '../components/Cycle/TopNavigation/TopNavigationSitecore';
import VideoContainerSitecore from '../components/Cycle/VideoContainerSitecore';
import JssAuthenticationSitecore from '../components/JssAuthenticationSitecore';
import CycleContactFormRequestSitecore from '../components/Modules/Contact/CycleContactFormRequestSitecore';
import CycleFunnelCarSitecore from '../components/Modules/Funnels/CycleFunnelCarSitecore';
import CycleFunnelLegalAidSitecore from '../components/Modules/Funnels/CycleFunnelLegalAidSitecore';
import CycleFunnelTravelChangeSitecore from '../components/Modules/Funnels/CycleFunnelTravelChangeSitecore';
import CycleFunnelTravelSitecore from '../components/Modules/Funnels/CycleFunnelTravelSitecore';
import FunnelContentsSitecore from '../components/Modules/Funnels/FunnelContentsSitecore';
import FunnelHomeOwnerSitecore from '../components/Modules/Funnels/FunnelHomeOwnerSitecore';
import FunnelLiabilityChangeSitecore from '../components/Modules/Funnels/FunnelLiabilityChangeSitecore';
import FunnelLiabilitySitecore from '../components/Modules/Funnels/FunnelLiabilitySitecore';
import FunnelWeddingSitecore from '../components/Modules/Funnels/FunnelWeddingSitecore';
import HomeContentsPreFunnel from '../components/Modules/Funnels/HomeContentsPreFunnel';
import LicensePlateSitecore from '../components/Modules/Funnels/LicensePlateSitecore';
import TravelPreFunnel from '../components/Modules/Funnels/TravelPreFunnel';
import AdvisorContactDetails from '../components/Modules/MyZone/AdvisorContactDetails';
import BusinessPackages from '../components/Modules/MyZone/BusinessPackages';
import CoveragesCard from '../components/Modules/MyZone/Cards/CoveragesCard';
import DetailsCard from '../components/Modules/MyZone/Cards/DetailsCard';
import DirectLinksCard from '../components/Modules/MyZone/Cards/DirectLinksCard';
import DiscountCard from '../components/Modules/MyZone/Cards/DiscountCard';
import DocumentsCard from '../components/Modules/MyZone/Cards/DocumentsCard';
import MyInsuranceCard from '../components/Modules/MyZone/Cards/MyInsuranceCard';
import PremiumCard from '../components/Modules/MyZone/Cards/PremiumCard';
import CedPreflight from '../components/Modules/MyZone/CedPreflight';
import ContactDetailsZakelijk from '../components/Modules/MyZone/ContactDetailsZakelijk';
import ContactPeople from '../components/Modules/MyZone/ContactPeople';
import CorrespondenceDetails from '../components/Modules/MyZone/CorrespondenceDetails';
import CycleBankAccountNumberSitecore from '../components/Modules/MyZone/CycleBankAccountNumberSitecore';
import CycleCancelPolicySitecore from '../components/Modules/MyZone/CycleCancelPolicySitecore';
import CycleChangeAddressSitecore from '../components/Modules/MyZone/CycleChangeAddressSitecore';
import CycleChangeContactDetailsSitecore from '../components/Modules/MyZone/CycleChangeContactDetailsSitecore';
import CycleChangePolicySitecore from '../components/Modules/MyZone/CycleChangePolicySitecore';
import CycleClaimFormSitecore from '../components/Modules/MyZone/CycleClaimFormSitecore';
import CycleCollectivityPickerSitecore from '../components/Modules/MyZone/CycleCollectivityPickerSitecore';
import CycleContactDetailsSitecore from '../components/Modules/MyZone/CycleContactDetailsSitecore';
import CycleHeaderMyzoneSitecore from '../components/Modules/MyZone/CycleHeaderMyzoneSitecore';
import CycleMyInsurancesListSitecore from '../components/Modules/MyZone/CycleMyInsurancesListSitecore';
import CycleMyInvoicesSitecore from '../components/Modules/MyZone/CycleMyInvoicesSitecore';
import CyclePersonalDetailsSitecore from '../components/Modules/MyZone/CyclePersonalDetailsSitecore';
import DocumentClaimsDetails from '../components/Modules/MyZone/DocumentClaimsDetails';
import DocumentsFilter from '../components/Modules/MyZone/DocumentsFilter';
import GreenCardRequestForm from '../components/Modules/MyZone/GreenCardRequestForm';
import InsuranceEntryZakelijk from '../components/Modules/MyZone/InsuranceEntryZakelijk';
import MyDamages from '../components/Modules/MyZone/MyDamages';
import MyInsurancesZakelijk from '../components/Modules/MyZone/MyInsurancesZakelijk';
import MyInsuranceTable from '../components/Modules/MyZone/MyInsuranceTable';
import PersonalDetailsZakelijk from '../components/Modules/MyZone/PersonalDetailsZakelijk';
import PolicyDetailIntro from '../components/Modules/MyZone/PolicyDetailIntro';
import PortfolioList from '../components/Modules/MyZone/PortfolioList';
import ReplyMessage from '../components/Modules/MyZone/ReplyMessage';
import TerminatedInsurancesCTA from '../components/Modules/MyZone/TerminatedInsurancesCTA';
import DocumentsWrapper from '../components/Modules/MyZone/wrappings/DocumentsWrapper';
import RapidFormCanvas from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormCanvas/RapidFormCanvas';
import RapidFormBannerContentField from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/fields/RapidFormBannerContentField';
import RapidFormContentField from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/fields/RapidFormContentField';
import RapidFormSuggestionWidget from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/fields/RapidFormSuggestionWidget';
import PopoverTooltip from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/molecules/PopoverTooltip';
import TooltipFeedback from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/molecules/TooltipFeedback';
import RapidFormField from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/RapidFormField';
import RapidFormInputContainer from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/RapidFormInputContainer';
import RapidFormCheckoutWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormCheckoutWrapper';
import RapidFormCurrencyWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormCurrencyWrapper';
import RapidFormDateWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormDateWrapper';
import RapidFormInputRadioTileWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormInputRadioTileWrapper';
import RapidFormPortalWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormPortalWrapper';
import RapidFormProductWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormProductWrapper';
import RapidFormRadioBarWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormRadioBarWrapper';
import RapidFormRadioWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormField/wrappings/RapidFormRadioWrapper';
import RapidFormFieldSet from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormFieldSet/RapidFormFieldSet';
import RapidFormFieldSetStickyWrapper from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormFieldSet/wrappings/RapidFormFieldSetStickyWrapper';
import RapidFormStepIndication from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormStepIndication/RapidFormStepIndication';
import RapidFormValidationContainer from '../components/Modules/RapidFormPlayer/components/RapidFormComponents/RapidFormValidationContainer/RapidFormValidationContainer';
import RapidFormPlayer from '../components/Modules/RapidFormPlayer/components/RapidFormPlayer';
import CategorizedInsurancesCard from '../components/Modules/WSM/CategorizedInsurancesCard';
import CollectivityIntroSitecore from '../components/Modules/WSM/CollectivityIntroSitecore';
import CollectivityLogoSitecore from '../components/Modules/WSM/CollectivityLogoSitecore';
import CollectivityProductsSitecore from '../components/Modules/WSM/CollectivityProductsSitecore';
import InsuranceDisplayCards from '../components/Modules/WSM/InsuranceDisplayCards';
import MyServicesSitecore from '../components/Modules/WSM/MyServicesSitecore';
import ServicesDisplayCards from '../components/Modules/WSM/ServicesDisplayCards';
import SubCollectivitiesList from '../components/Modules/WSM/SubCollectivitiesList';
import TopbarSitecore from '../components/Modules/WSM/TopbarSitecore';
import SiteWideNotificationBar from '../components/SiteWideNotificationBar/SiteWideNotificationBar';

const components = new Map();
components.set('CardWrapper', CardWrapper);
components.set('ArticleSitecore', ArticleSitecore);
components.set('AsideSitecore', AsideSitecore);
components.set('BaseNavigation', BaseNavigation);
components.set('BlogAuthor', BlogAuthor);
components.set('BlogCarousel', BlogCarousel);
components.set('BlogDivider', BlogDivider);
components.set('BlogHero', BlogHero);
components.set('BlogSearch', BlogSearch);
components.set('BlogTag', BlogTag);
components.set('BlogTags', BlogTags);
components.set('Breadcrumb', Breadcrumb);
components.set('Carousel', Carousel);
components.set('CarouselStacked', CarouselStacked);
components.set('StackedReviewCarousel', StackedReviewCarousel);
components.set('CategorizedFaq', CategorizedFaq);
components.set('CategorizedFaqList', CategorizedFaqList);
components.set('FaqCategory', FaqCategory);
components.set('FaqSubCategory', FaqSubCategory);
components.set('ClickSimulatorSitecore', ClickSimulatorSitecore);
components.set('CompareTableSitecore', CompareTableSitecore);
components.set('ContentToggleSitecore', ContentToggleSitecore);
components.set('CycleAnvaOnlineIframeSitecore', CycleAnvaOnlineIframeSitecore);
components.set('CycleCompareCoverageSitecore', CycleCompareCoverageSitecore);
components.set('CycleContentBlockSitecore', CycleContentBlockSitecore);
components.set('CycleCookieConsentSitecore', CycleCookieConsentSitecore);
components.set('CycleCookieToggleSitecore', CycleCookieToggleSitecore);
components.set('CycleCoverageSitecore', CycleCoverageSitecore);
components.set('CycleFaqSitecore', CycleFaqSitecore);
components.set('CycleFooterSitecore', CycleFooterSitecore);
components.set('CycleHeaderSitecore', CycleHeaderSitecore);
components.set('CycleHeadingSitecore', CycleHeadingSitecore);
components.set('CycleIframeSitecore', CycleIframeSitecore);
components.set('CycleIFrameSizeEmitterSitecore', CycleIFrameSizeEmitterSitecore);
components.set('CycleLanguageSwitchSitecore', CycleLanguageSwitchSitecore);
components.set('CycleLinkCardSitecore', CycleLinkCardSitecore);
components.set('CycleListSitecore', CycleListSitecore);
components.set('CycleNavigationSitecore', CycleNavigationSitecore);
components.set('CycleNotificationSitecore', CycleNotificationSitecore);
components.set('CyclePageIntroSitecore', CyclePageIntroSitecore);
components.set('CycleRadioNavigationSitecore', CycleRadioNavigationSitecore);
components.set('CycleSectionSitecore', CycleSectionSitecore);
components.set('CycleTileSitecore', CycleTileSitecore);
components.set('CycleTilesSitecore', CycleTilesSitecore);
components.set('FixedBox', FixedBox);
components.set('FixedLink', FixedLink);
components.set('GridComponentAdapterSitecore', GridComponentAdapterSitecore);
components.set('HorizontalCard', HorizontalCard);
components.set('HtmlSitecore', HtmlSitecore);
components.set('IconButtonSitecore', IconButtonSitecore);
components.set('IframeCleanSitecore', IframeCleanSitecore);
components.set('ListContainer', ListContainer);
components.set('ListContentBlock', ListContentBlock);
components.set('LocationMap', LocationMap);
components.set('PortalSitecore', PortalSitecore);
components.set('PortalTargetSitecore', PortalTargetSitecore);
components.set('premiumCalcSitecore', premiumCalcSitecore);
components.set('ProductCard', ProductCard);
components.set('RationalHero', RationalHero);
components.set('ReviewSitecore', ReviewSitecore);
components.set('SocialMediaShare', SocialMediaShare);
components.set('StickyBox', StickyBox);
components.set('StoryteqContainer', StoryteqContainer);
components.set('StructuredData', StructuredData);
components.set('StructuredDataBlog', StructuredDataBlog);
components.set('StructuredDataFaq', StructuredDataFaq);
components.set('SubGridSitecore', SubGridSitecore);
components.set('TopNavigationSitecore', TopNavigationSitecore);
components.set('VideoContainerSitecore', VideoContainerSitecore);
components.set('JssAuthenticationSitecore', JssAuthenticationSitecore);
components.set('CycleContactFormRequestSitecore', CycleContactFormRequestSitecore);
components.set('CycleFunnelCarSitecore', CycleFunnelCarSitecore);
components.set('CycleFunnelLegalAidSitecore', CycleFunnelLegalAidSitecore);
components.set('CycleFunnelTravelChangeSitecore', CycleFunnelTravelChangeSitecore);
components.set('CycleFunnelTravelSitecore', CycleFunnelTravelSitecore);
components.set('FunnelContentsSitecore', FunnelContentsSitecore);
components.set('FunnelHomeOwnerSitecore', FunnelHomeOwnerSitecore);
components.set('FunnelLiabilityChangeSitecore', FunnelLiabilityChangeSitecore);
components.set('FunnelLiabilitySitecore', FunnelLiabilitySitecore);
components.set('FunnelWeddingSitecore', FunnelWeddingSitecore);
components.set('HomeContentsPreFunnel', HomeContentsPreFunnel);
components.set('LicensePlateSitecore', LicensePlateSitecore);
components.set('TravelPreFunnel', TravelPreFunnel);
components.set('AdvisorContactDetails', AdvisorContactDetails);
components.set('BusinessPackages', BusinessPackages);
components.set('CoveragesCard', CoveragesCard);
components.set('DetailsCard', DetailsCard);
components.set('DirectLinksCard', DirectLinksCard);
components.set('DiscountCard', DiscountCard);
components.set('DocumentsCard', DocumentsCard);
components.set('MyInsuranceCard', MyInsuranceCard);
components.set('PremiumCard', PremiumCard);
components.set('CedPreflight', CedPreflight);
components.set('ContactDetailsZakelijk', ContactDetailsZakelijk);
components.set('ContactPeople', ContactPeople);
components.set('CorrespondenceDetails', CorrespondenceDetails);
components.set('CycleBankAccountNumberSitecore', CycleBankAccountNumberSitecore);
components.set('CycleCancelPolicySitecore', CycleCancelPolicySitecore);
components.set('CycleChangeAddressSitecore', CycleChangeAddressSitecore);
components.set('CycleChangeContactDetailsSitecore', CycleChangeContactDetailsSitecore);
components.set('CycleChangePolicySitecore', CycleChangePolicySitecore);
components.set('CycleClaimFormSitecore', CycleClaimFormSitecore);
components.set('CycleCollectivityPickerSitecore', CycleCollectivityPickerSitecore);
components.set('CycleContactDetailsSitecore', CycleContactDetailsSitecore);
components.set('CycleHeaderMyzoneSitecore', CycleHeaderMyzoneSitecore);
components.set('CycleMyInsurancesListSitecore', CycleMyInsurancesListSitecore);
components.set('CycleMyInvoicesSitecore', CycleMyInvoicesSitecore);
components.set('CyclePersonalDetailsSitecore', CyclePersonalDetailsSitecore);
components.set('DocumentClaimsDetails', DocumentClaimsDetails);
components.set('DocumentsFilter', DocumentsFilter);
components.set('GreenCardRequestForm', GreenCardRequestForm);
components.set('InsuranceEntryZakelijk', InsuranceEntryZakelijk);
components.set('MyDamages', MyDamages);
components.set('MyInsurancesZakelijk', MyInsurancesZakelijk);
components.set('MyInsuranceTable', MyInsuranceTable);
components.set('PersonalDetailsZakelijk', PersonalDetailsZakelijk);
components.set('PolicyDetailIntro', PolicyDetailIntro);
components.set('PortfolioList', PortfolioList);
components.set('ReplyMessage', ReplyMessage);
components.set('TerminatedInsurancesCTA', TerminatedInsurancesCTA);
components.set('DocumentsWrapper', DocumentsWrapper);
components.set('RapidFormCanvas', RapidFormCanvas);
components.set('RapidFormBannerContentField', RapidFormBannerContentField);
components.set('RapidFormContentField', RapidFormContentField);
components.set('RapidFormSuggestionWidget', RapidFormSuggestionWidget);
components.set('PopoverTooltip', PopoverTooltip);
components.set('TooltipFeedback', TooltipFeedback);
components.set('RapidFormField', RapidFormField);
components.set('RapidFormInputContainer', RapidFormInputContainer);
components.set('RapidFormCheckoutWrapper', RapidFormCheckoutWrapper);
components.set('RapidFormCurrencyWrapper', RapidFormCurrencyWrapper);
components.set('RapidFormDateWrapper', RapidFormDateWrapper);
components.set('RapidFormInputRadioTileWrapper', RapidFormInputRadioTileWrapper);
components.set('RapidFormPortalWrapper', RapidFormPortalWrapper);
components.set('RapidFormProductWrapper', RapidFormProductWrapper);
components.set('RapidFormRadioBarWrapper', RapidFormRadioBarWrapper);
components.set('RapidFormRadioWrapper', RapidFormRadioWrapper);
components.set('RapidFormFieldSet', RapidFormFieldSet);
components.set('RapidFormFieldSetStickyWrapper', RapidFormFieldSetStickyWrapper);
components.set('RapidFormStepIndication', RapidFormStepIndication);
components.set('RapidFormValidationContainer', RapidFormValidationContainer);
components.set('RapidFormPlayer', RapidFormPlayer);
components.set('CategorizedInsurancesCard', CategorizedInsurancesCard);
components.set('CollectivityIntroSitecore', CollectivityIntroSitecore);
components.set('CollectivityLogoSitecore', CollectivityLogoSitecore);
components.set('CollectivityProductsSitecore', CollectivityProductsSitecore);
components.set('InsuranceDisplayCards', InsuranceDisplayCards);
components.set('MyServicesSitecore', MyServicesSitecore);
components.set('ServicesDisplayCards', ServicesDisplayCards);
components.set('SubCollectivitiesList', SubCollectivitiesList);
components.set('TopbarSitecore', TopbarSitecore);
components.set('SiteWideNotificationBar', SiteWideNotificationBar);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
